import { getSession } from "../auth/authService";

export const initialUiState = {
  session: getSession(),
  sidebarOpen: false,
  pendingPath: "",
  modals: {
    buyerAccount: false,
    buyerInfo: false,
    install: false,
    officeLogin: false,
    systemInfo: false,
    clientAccess: false,
    guestLock: false,
  },
};

export function uiReducer(state = initialUiState, action) {
  switch (action.type) {
    case "SET_SESSION":
      return { ...state, session: action.payload };
    case "CLEAR_SESSION":
      return {
        ...state,
        session: null,
        pendingPath: "",
        modals: {
          buyerAccount: false,
          buyerInfo: false,
          install: false,
          officeLogin: false,
          systemInfo: false,
          clientAccess: false,
          guestLock: false,
        },
      };
    case "OPEN_MODAL":
      return {
        ...state,
        modals: { ...state.modals, [action.payload]: true },
      };
    case "CLOSE_MODAL":
      return {
        ...state,
        modals: { ...state.modals, [action.payload]: false },
      };
    case "TOGGLE_SIDEBAR":
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case "SET_SIDEBAR":
      return { ...state, sidebarOpen: Boolean(action.payload) };
    case "SET_PENDING_PATH":
      return { ...state, pendingPath: action.payload || "" };
    default:
      return state;
  }
}
